import { toastr } from 'react-redux-toastr';
import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_FORM_BY_ID_REQUEST = 'GET_FORM_BY_ID_REQUEST';
export const GET_FORM_BY_ID_SUCCESS = 'GET_FORM_BY_ID_SUCCESS';
export const GET_FORM_BY_ID_FAILURE = 'GET_FORM_BY_ID_FAILURE';
/* eslint-disable max-len */
function requestGetFormById() {
  return {
    type: GET_FORM_BY_ID_REQUEST,
    isGettingFormById: true,
    formByIdResponse: null,
    validationResult: null,
    supportingDocs: null,
    formReviewState: null,
    workflowState: null,
    viewPdfData: null,
    formByIdError: null
  };
}

function receiveGetFormById(formByIdResponse, validationResult, supportingDocs, formReviewState, workflowState) {
  return {
    type: GET_FORM_BY_ID_SUCCESS,
    isGettingFormById: false,
    formByIdResponse,
    validationResult,
    supportingDocs,
    formReviewState,
    workflowState,
    formByIdError: null
  };
}

function rejectGetFormById(formByIdError) {
  return {
    type: GET_FORM_BY_ID_FAILURE,
    isGettingFormById: false,
    formByIdError
  };
}

export function getFormById(formType, formId) {
  return (dispatch) => {
    const promise = () => {
      dispatch(requestGetFormById());

      ApiService
        .getFormById(formType, formId)
        .then((response) => {
          if (response.data != null && response.data.form != null && response.data.form.ocrIssues === true) {
            toastr.info('', 'The form appears to be non-standard or corrupt.  Recommend manual input.');
          }
          if (response.data != null && response.data.form != null && response.data.form.aiSkipped === true) {
            toastr.info('', 'OCR was skipped because AI functionality is disabled for this Client or Legal Entity.  Please enter the form details manually.');
          }
          if (response.data && response.data.form) {
            response.data.form.customerDbId = response.data.customer;
            response.data.form.accountId = response.data.account;
            response.data.form.hasParentAccount = response.data.hasParentAccount;
            response.data.form.hasAllocationStatement = response.data.hasAllocationStatement;
            response.data.form.hasImyTopLevelAccount = response.data.hasImyTopLevelAccount;
            response.data.form.hasSavedPdf = response.data.hasSavedPdf;
            response.data.form.accountNumber = response.data.accountNumber;
            response.data.form.formId = formId;
            response.data.form.tinMatchResult = response.data.tinMatchResult;
            response.data.form.collectableSupportingDocs = response.data.collectableSupportingDocs;
            response.data.form.currentWorkflowStage = response.data.workflow.stage;
          }
          dispatch(receiveGetFormById(
            response.data.form,
            response.data.validationResults,
            response.data.supportingDocs,
            response.data.review,
            response.data.workflow
          ));
        })
        .catch((error) => {
          if (!error.response && error.retries && error.retries > 1) {
            ApiService.addQueuedPromise(promise, error);
          }

          if (error.response || (error.retries && error.retries > 1)) {
            const status = error.response && error.response.data && error.response.data.code;
            if (status !== 401) {
              dispatch(handleException(error, rejectGetFormById, !status || (status !== 404 && status !== 401)));
            }
          }
        });
    };

    return promise();
  };
}
